import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Switch,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { ModalHeader } from "../../common/modalHeader";
import { getAllCustomerDetail } from "../../common/searchModal/api";
import { addWhatAppGroup } from "./customerGroupingApi";

import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import { validationOnKey } from "./addGroupValidation";
const data = {
  categoryName: "",
  items: [],
};

export default function AddCategories({
  selectedCategories,
  section,
  selectedItems,
  setSelectedItems,
  
  open,
  addCategoriesData,
  updateCategoriesData,
  setOpen,
}) {
  const [itemData, setItemData] = useState(data);
  const [allItems, setAllItems] = useState([]);

  const onClose = () => {
    setItemData(data);
    setOpen(false);
    // setSelectedItems([]);
  };

  useEffect(() => {
    
  }, [allItems, selectedCategories]);
  

  useEffect(()=>  
  {
    if(open){

    }
    else{
      setItemData({categoryName:""})
    }

  },[open])
 useEffect(()=>{
  getAllCustomerDetail(
    {

      page: 1,
      pageSize: 1000,
      filter: "",
      search: "",
      filter2: "",
      search2: ""
    }, (data) => {
      setAllItems(data)
      console.log("data detail ", data)
    })
 },[])
  useEffect(() => {
    // if (selectedCategories) {
    //   setItemData({ ...itemData, ...selectedCategories });
    // }
  }, [selectedCategories]);

  return (
    <Dialog open={open} fullWidth={true} maxWidth="xs" onClose={onClose}>
     
      <ModalHeader title={"Customer Group"} 
        onClose={(data)=>{
          setOpen(data)
        }}
        />
      {/* <DialogTitle color="primary"></DialogTitle> */}
      
      <DialogContent sx={{ p: 1 }}>
        <Box sx={{ mt: 2, paddingX: "1rem" }}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            value={itemData.categoryName}
            onChange={(e) => {
              setItemData({ ...itemData, categoryName: e.target.value });
            }}
            label={
              <span>
                Enter Group<span style={{ color: "red" }}>*</span>
              </span>
            }
          />
          <FormControl sx={{ width: "100%" }} component="fieldset">
            {allItems
               
              ?.map((item2, index) => {
                return (
                  <FormGroup
                    sx={{ width: "100%" }}
                    aria-label="position"
                    row
                    key={"notAssigntable" + index}
                  >
                    <FormControlLabel
                      sx={{
                        width: "100%",
                        justifyContent: "space-between",
                        px: 2,
                        m: 0,
                      }}
                      control={
                        <Checkbox
                           
                          onChange={(e) => {
                            
                          
                          }}
                        />
                      }
                      label={item2?.name}
                      labelPlacement="start"
                    />
                  </FormGroup>
                );
              })}
          </FormControl>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
           
          variant="contained"
          onClick={() => {
            // if()
            let isValid=validationOnKey({...itemData})
            if(!isValid.status){
              Swal.fire({
                text: isValid.text,
                icon: "warning",
                ...swalAlertPopProps,
              });
            }
            else{
              addWhatAppGroup({
                customerGroupName:itemData?.categoryName
              },()=>{
                getAllCustomerDetail(
                  {
              
                    page: 1,
                    pageSize: 1000,
                    filter: "",
                    search: "",
                    filter2: "",
                    search2: ""
                  }, (data) => {
                    setAllItems(data)
                    console.log("data detail ", data)
                  })
              })
            }
           
            setOpen(false); 
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
